import React from 'react';

export default function ManageAnalytics(): JSX.Element {
  return <div>analytics report to be done</div>;
}
